module.exports = __webpack_public_path__ + "assets/img/ad344bb8ce0d3b499ca6efa97ad0eeea.svg";